// extracted by mini-css-extract-plugin
export default {"SliderSwitch":"SliderSwitch_SliderSwitch__MOCvv","Slider":"SliderSwitch_Slider__c4R2w","disabled":"SliderSwitch_disabled__70rpl"};